import React, { useEffect } from 'react';
import { FullSizeColumn } from '../../../../Components/FlexBox';
import FormTextField from '../../../../Components/Form/FormTextField';
import FormDatePicker from '../../../../Components/Form/FormDatePicker';
import { useFormContext } from 'react-hook-form';

const CampaignDialogContent = function CampaignDialogContent({
  handleChangeDisableSubmit,
  defaultData = null,
}) {
  const { watch, setValue, reset } = useFormContext();

  useEffect(() => {
    const description = watch('description');
    const startDate = watch('startDate');
    const endDate = watch('endDate');
    handleChangeDisableSubmit(!(description && startDate && endDate));
  }, [watch('description'), watch('startDate'), watch('endDate')]);

  useEffect(() => {
    if (!defaultData) {
      reset();
      setValue('description', '');
      setValue('startDate', null);
      setValue('endDate', null);
    }
    if (defaultData) {
      setValue('id', defaultData.id);
      setValue('description', defaultData.description);
      setValue(
        'startDate',
        defaultData.startDate ? new Date(defaultData.startDate) : null
      );
      setValue(
        'endDate',
        defaultData.endDate ? new Date(defaultData.endDate) : null
      );
    }
  }, [defaultData]);

  return (
    <FullSizeColumn gap="8px">
      <FormTextField
        name="description"
        allUpperCase
        required
        defaultValue={defaultData?.description || ''}
      />
      <FormDatePicker
        name="startDate"
        required
        minDate={new Date()}
        defaultValue={
          defaultData?.startDate ? new Date(defaultData.startDate) : null
        }
      />
      <FormDatePicker
        name="endDate"
        required
        minDate={watch('startDate') || new Date()}
        defaultValue={
          defaultData?.endDate ? new Date(defaultData.endDate) : null
        }
      />
    </FullSizeColumn>
  );
};

export default CampaignDialogContent;
